import { useMemo, useRef } from "react";
import { signal } from "@preact/signals-react";

import poolFilter from "componentsv2/form/poollFilters";
import Button from "componentsv2/button/Button";
import { TrashIcon } from "components/Icons";
import { useTable } from "storev2/tableStore";
import { BuildFilterDomain } from "./BuildFilterDomain";
import { FilterIcon } from "components/Icons/linear";
import { classNames as cn } from "tools/ui";

const filters = signal({});
const showFilters = signal(true);
const resetKey = signal(0);

function TableCustomFilter({ layout, storeId, setFilterDomain }) {
  const { reload } = useTable();
  const pool = poolFilter();
  const filterSearch = useRef(null);

  const filterFields = useMemo(() => {
    return Object.entries(layout.fields)
      .filter(([_, field]) => field.filter)
      .map(([name, field]) => ({ name, ...field }));
  }, [layout]);

  function Search() {
    filterSearch.current = handleSearch();
  }

  function handleChange(fieldName, value) {
    filters.value = { ...filters.value, [fieldName]: value };
    Search();
  }

  async function handleSearch() {
    const domain = BuildFilterDomain(layout, filters.value);
    if (setFilterDomain) {
      setFilterDomain(domain);
    } else {
      await reload(storeId, { search: domain });
    }
  }

  async function handleClear() {
    filters.value = {};
    resetKey.value++;
    if (setFilterDomain) {
      setFilterDomain(null);
    } else {
      await reload(storeId, { search: [] });
    }
  }

  function build(field, idx) {
    const Component = pool[field.widget || field.type];
    if (!Component) return null;

    const attrs = {
      storeId,
      layout,
      ...field,
      name: field.name,
      onChange: handleChange,
      placeholder:
        `${layout.model}.${field.name}.filter` || field.label || field.name,
      value: filters.value[field.name] || "",
    };

    return (
      <div key={`${idx}-${resetKey.value}`} className="min-w-[50px] ">
        <Component {...attrs} />
      </div>
    );
  }

  return filterFields.length > 0 ? (
    <div
      className="flex flex-col md:flex-row md:items-center justify-between gap-3 mb-3 w-full"
      id="table-custom-filter"
    >
      <div
        className={cn(
          "w-full grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-3",
          showFilters.value ? "" : "hidden md:invisible md:grid",
        )}
      >
        {filterFields.map((field, idx) => build(field, idx))}
      </div>
      <div className="flex gap-2 items-center max-md:w-full">
        {Object.keys(filters.value).length > 0 && (
          <Button
            style="font-medium !rounded-xl shadow-sm"
            color="rose"
            height="h-10"
            size="w-full"
            onClick={handleClear}
            title="Limpiar filtros"
            iconRight={<TrashIcon className="size-4 text-white fill-current" />}
          />
        )}

        <Button
          style="font-medium !rounded-xl shadow-sm"
          color="neutralDark"
          height="h-10"
          size="w-full"
          title={showFilters.value ? "Ocultar filtros" : "Mostrar filtros"}
          onClick={() => (showFilters.value = !showFilters.value)}
          iconRight={<FilterIcon className="size-4 text-white fill-current" />}
        />
      </div>
    </div>
  ) : null;
}

export default TableCustomFilter;
